import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import _notification from 'modules/notification';
import { Card, Table, Modal, Tag } from 'antd';
import PageHeader from 'components/enterprise/PageHeader';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import ConfirmPopup from '../popup/ConfirmPopup';
import MyInput from 'components/controls/MyInput';
import DropdownList from 'components/controls/DropdownList';
import { routesAdmin } from 'routes/Routes';
import { GENERAL_ERROR_MESSAGE, ROOT_PATH } from 'constants/constants';
import FileUpload from '../../components/controls/FileUpload';
import xls from '../../assets/template/BankTxnFileTemplate.xlsx';
import _authService from '../../modules/AuthService';

class ExportAttendanceSheet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            post: "",
            status: '',
            exams: [],
            loading: false,
        };
    }

    componentDidMount() {
        this.getAllExams();
    }

    getAllExams = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let examsList = await _AdminService.GetAllPost();

                    let examAllArray = [{
                        Id: "0",
                        Name: "All"
                    }];

                    let examArray = examsList.data

                    const finalExamArray = [...examAllArray, ...examArray];


                    this.setState({
                        ...this.state,
                        exams: finalExamArray,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    handleDownload = async (input) => {
        //console.log("reached: ", this.state);

        if(this.state.post===""){
            _notification.showMessage('error', "Please select Post/Exam.");
            return;
        }

        if(!this.state.status){
            _notification.showMessage('error', "Please select Approved/Rejected status.");
            return;
        }

        try {
            this.setState({ loading: true }, async () => {
                try {

                    const response = await _AdminService.GetAllStudentsAttendanceSheet(this.state.post, this.state.status);
                    //console.log("File response: ", response.data);
                    if (response.status == 200) {
                        //console.log('Final URL: ', _AdminService.GetAttendanceURL(response.data));

                        let alink = document.createElement('a');
                        alink.href = _AdminService.GetAttendanceURL(response.data);
                        alink.download = response.data;
                        alink.click();

                        //_notification.showMessage('success', "File uploaded successfully.");
                        this.setState({
                            loading: false,
                            //post: "",
                            //status: 0,
                        });
                    }
                    else {
                        _notification.showMessage('error', response.data.message);
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }
    }

    onPostChange = (event) => {
        this.setState({
            ...this.state,
            post: event.target.value
        });
    }

    onStateChange = (event) => {
        this.setState({
            ...this.state,
            status: event.target.value
        });
    }

    render() {

        if (this.state.loading)
            return <LoadingSpinner />

        return (

            <div className="container-fluid p-3">
                <div className="max1200 m-auto">
                    <PageHeader
                        title="Attendance Sheet"
                        breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Reports' }, { label: 'Attendance Sheet' }]}
                    />
                    <div className="ent-panel mb-4">
                        <div className="admin-inner-wrap p-3">
                            <div className="row flex-sm-row ">
                                <div className="col-sm-6">
                                    <DropdownList
                                        value={this.state.post}
                                        name="ParentId"
                                        onChange={this.onPostChange}
                                        placeholder="Select Post"
                                        heading={"Post/Exam"}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        options={this.state.exams}
                                    // errorState={this.state.degreeError}
                                    // errorMessage={this.state.degreeError}
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <DropdownList
                                        value={this.state.status}
                                        name="ParentId"
                                        onChange={this.onStateChange}
                                        placeholder="Select Status"
                                        heading={"Approved/Rejected"}
                                        className="w-100"
                                        wrapClass="wrap"
                                        isRequired={true}
                                        options={[{ Id: 0, Name: "All" }, { Id: 1, Name: "Approved" }, { Id: 2, Name: "Rejected" }]}
                                    // errorState={this.state.degreeError}
                                    // errorMessage={this.state.degreeError}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="pt-4 buttonAlignCenter" >
                            <button type="button" onClick={this.handleDownload} className="button-global button-primary autoHeight autoWidth"><span>Download Attendance Sheet</span></button>
                        </div>
                    </div>
                </div> 
            </div>

        )
    };
}

export default ExportAttendanceSheet;